/*
 * Bundle Promo Banner — v4.0 (opt-in, allow-list, preview-gated)
 *
 * Server-side Liquid handles the first paint (correct for deep links and
 * non-JS browsers). This script subscribes to the theme's variant-change
 * event and toggles the banner whenever the selected variant's color
 * changes.
 *
 * Eligibility rule on the client (matches the server-side Liquid):
 *   1. Promo metaobject configured     (hasPromo)
 *   2. Product opted in                (productOptedIn)
 *   3. Preview gate passes             (previewGatePass)
 *   4. Either no Color option present (colorOptionIndex === 0)
 *      OR the new variant's color is in the eligibleColors allow-list.
 *
 * Empty `eligibleColors` with a Color option present is restrictive (fail).
 *
 * The snippet emits a per-section
 *   <script type="application/json" data-bundle-promo-config> blob with:
 *     {
 *       hasPromo: boolean,
 *       productOptedIn: boolean,
 *       previewGatePass: boolean,
 *       colorOptionIndex: 1 | 2 | 3 | 0,
 *       eligibleColors: ["amethyst", "peacock", ...]  // lowercased + stripped
 *     }
 * The preview gate is resolved server-side per request — JS just reads
 * the resulting boolean. If it's false, the banner stays hidden.
 *
 * Subscribes to theme.PUB_SUB_EVENTS.variantChange, payload
 *   { data: { sectionId, variant: <shopify variant json> } }
 */
(function () {
  if (window.__bundlePromoBannerInit) return;
  window.__bundlePromoBannerInit = true;

  function readConfig(sectionId) {
    var el = document.querySelector(
      '[data-bundle-promo-config][data-section-id="' + sectionId + '"]'
    );
    if (!el) return null;
    try {
      return JSON.parse(el.textContent || '{}');
    } catch (e) {
      return null;
    }
  }

  function normalize(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function isEligible(config, variant) {
    if (!config) return false;
    if (!config.hasPromo) return false;
    if (!config.productOptedIn) return false;
    if (!config.previewGatePass) return false;
    if (!variant) return false;
    if (!config.colorOptionIndex) return true; // no Color option → fallback pass
    var color = normalize(variant['option' + config.colorOptionIndex]);
    if (!color) return false;
    var eligible = config.eligibleColors || [];
    if (eligible.length === 0) return false; // empty list = restrictive
    return eligible.indexOf(color) !== -1;
  }

  function applyToBanner(sectionId, variant) {
    var banner = document.querySelector(
      '[data-bundle-promo-banner][data-section-id="' + sectionId + '"]'
    );
    if (!banner) return;
    var config = readConfig(sectionId);
    if (isEligible(config, variant)) {
      banner.removeAttribute('hidden');
    } else {
      banner.setAttribute('hidden', '');
    }
  }

  function init() {
    if (
      !window.theme ||
      !window.theme.PUB_SUB_EVENTS ||
      typeof window.subscribe !== 'function'
    ) {
      return false;
    }
    window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, function (event) {
      var data = event && event.data;
      if (!data || !data.sectionId) return;
      applyToBanner(data.sectionId, data.variant);
    });
    return true;
  }

  if (!init()) {
    document.addEventListener('DOMContentLoaded', function () {
      if (!init()) {
        setTimeout(init, 500);
      }
    });
  }
})();
